import {
  activityLogConstants,
  activityLog_nameSpace,
} from "../constants/activityLog.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null,
};

export const activityLog = (state = initialState, action) => {
  switch (action.type) {
    case activityLogConstants[`GET_${activityLog_nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request,
      };
    case activityLogConstants[`GET_${activityLog_nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null,
      };
    case activityLogConstants[`GET_${activityLog_nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };
    case activityLogConstants[`GET_${activityLog_nameSpace}_RESET`]:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};
